<template>
  <div :class="$style.prizePlaceCard">
    <img :class="$style.prizePlaceCardImage" :src="imageCard" alt="iconWinner" />
    <div :class="$style.prizePlaceCardBlock">
      <span :class="$style.prizePlaceCardTitle">{{ title }}</span>
      <span :class="$style.prizePlaceCardPrize">{{ snippet.format(prize) }}</span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useSnippet } from '~/composables/useSnippet';

defineProps({
  title: {
    type: String,
    default: '',
  },
  prize: {
    type: String,
    default: '',
  },
  imageCard: {
    type: String,
    default: '',
  },
});

const snippet = useSnippet();
</script>

<style lang="scss" module src="./prizePlaceCard.scss"></style>
